export const shop = {
  annotations: [
    {
      key: "orderer",
      label: "訂購人資訊",
      value: "{{customer.DELIVERY_NAME}}",
      required: true,
      type: "ORDERER",
      validation: null,
      prerequisities: null,
      placeholder: "",
      isSystem: true,
    },
    {
      key: "payment",
      label: "付款方式",
      value: "{{customer.PAYMENT_KEY}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: null,
      placeholder: "",
      sources: [
        // {
        //   key: "ATM",
        //   label: "ATM",
        // },
        // {
        //   key: "FACE",
        //   label: "面交付款",
        // },
        // {
        //   key: "CASH",
        //   label: "貨到付款",
        // },
        {
          key: "LINEPAY",
          label: "LINE PAY",
        },
        {
          key: "CREDIT",
          label: "信用卡(一次付清)",
        },
        {
          key: "CREDIT_INSTALLMENT",
          label: "信用卡(分期付款)",
        },
      ],
      isSystem: true,
    },
    {
      key: "delivery",
      label: "配送方式",
      value: "{{customer.DELIVERY_KEY}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: null,
      placeholder: "",
      sources: [
        {
          key: "HOME",
          label: "宅配",
        },
        // {
        //   key: "FACE",
        //   label: "面交",
        // },
        {
          key: "SEVEN",
          label: "7-Eleven",
        },
        {
          key: "FAMILY",
          label: "全家",
        },
        {
          key: "STORE",
          label: "門市自取",
        },
      ],
      isSystem: true,
    },
    {
      key: "DATE_37829574-d3f5-44d6-b663-b24e072ad443",
      label: "良辰吉日 來源面交",
      value: "{{customer.META.DATE_37829574-d3f5-44d6-b663-b24e072ad443}}",
      required: true,
      type: "DATE",
      mode: "LUNAR",
      validation: null,
      prerequisities: {
        delivery: "FACE",
      },
      placeholder: "請選擇農曆日期",
    },
    {
      key: "coupon",
      label: "折扣碼",
      value: "{{customer.META.coupon}}",
      required: false,
      type: "COUPON",
      validation: null,
      prerequisities: null,
      placeholder: "",
      isSystem: true,
    },
    {
      key: "point",
      label: "點數折抵",
      value: "{{customer.META.point}}",
      required: false,
      type: "POINT",
      validation: null,
      prerequisities: null,
      placeholder: "",
      isSystem: true,
    },
    {
      key: "account",
      label: "ATM後五碼",
      value: "{{customer.ACCOUNT}}",
      required: true,
      type: "INPUT",
      validation: [
        {
          regex: "^\\d{5}$",
          message: "",
        },
      ],
      prerequisities: [
        {
          payment: "ATM",
        },
      ],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "installment_month",
      label: "分期付款期數",
      value: "{{customer.installment_month}}",
      required: true,
      type: "OPTIONS",
      validation: null,
      prerequisities: [
        {
          payment: "CREDIT_INSTALLMENT",
        },
      ],
      placeholder: "",
      sources: [
        {
          key: "3",
          label: "3期",
        },
        {
          key: "6",
          label: "6期",
        },
        {
          key: "12",
          label: "12期",
        },
        {
          key: "18",
          label: "18期",
        },
        {
          key: "24",
          label: "24期",
        },
        {
          key: "30",
          label: "30期",
        },
      ],
      level: 2,
      isSystem: true,
    },
    {
      key: "branch",
      label: "取貨門市",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "BRANCH",
      validation: null,
      prerequisities: [
        {
          delivery: "STORE",
        },
      ],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "address",
      label: "配送地址",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "INPUT",
      validation: null,
      prerequisities: [
        {
          delivery: "HOME",
        },
        {
          cash_type: "HOME",
        },
      ],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "store_family",
      label: "全家門市",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "STORE_FAMILY",
      validation: null,
      prerequisities: [
        {
          delivery: "FAMILY",
        },
        {
          cash_type: "FAMILY",
        },
      ],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
    {
      key: "store_seven",
      label: "7-11門市",
      value: "{{customer.ADDRESS}}",
      required: true,
      type: "STORE_SEVEN",
      validation: null,
      prerequisities: [
        {
          delivery: "SEVEN",
        },
        {
          cash_type: "SEVEN",
        },
      ],
      placeholder: "",
      sources: [],
      level: 2,
      isSystem: true,
    },
  ],
  contact_href: "https://google.com?mock=0",
  shopSettings: {
    delivery_fee: {
      custom: 80,
      family: 60,
      home: 80,
      maxfree: 1000,
      seven: 60,
    },
    appreciationPeriod: 14,
    enableRewardPoint: true,
    rewardPoint: {
      restriction: {
        max: 0,
      },
      rules: [
        {
          condition: "gte",
          field: "amount",
          model: "PURCHASE_AMOUNT",
          value: 2000,
        },
        {
          condition: "inq",
          field: "tag_id",
          model: "CUSTOMER",
          value: [49],
        },
      ],
      scope: "ORDER",
      type: "PERCENT",
      value: 2,
    },
  },
  branches: [
    {
      type: "branch",
      name: "門市名稱1",
      addr: "門市地址",
      opening: "0000 - 2359",
      phone: "0912345678",
      url: "https://img.icons8.com/color/48/000000/shop.png",
    },
    {
      type: "branch",
      name: "門市名稱2",
      addr: "門市地址",
      opening: "0000 - 2359",
      phone: "0987654321",
      url: "https://img.icons8.com/color/48/000000/shop.png",
    },
  ],
  liff_id: "1655528008-kx0nyv3O",
  delivery_flow: ["HOME", "FACE", "SEVEN", "FAMILY", "STORE"],
  payment_flow: [
    "ATM",
    "FACE",
    "CASH",
    "LINEPAY",
    "CREDIT",
    "CREDIT_INSTALLMENT",
  ],
  payment_services: ["ECPAY", "LINEPAY"],
  contact_name: "Juan Tappie - LOCAL",
  avatar:
    "https://profile.line-scdn.net/0hWJxryuyaCGVFCx8Vq613MnlOBggyJQ4tPWoQVmlbBQc8Mks6cWVBCjUPVFxrb0o7eWgTAGIIXlU_",
  cod_target: ["HOME", "FAMILY", "SEVEN"],
  hasInvoice: true,
  enablePoint: true,
  id: 8,
};

export const shuffle = (array) =>
  array
    .map((value) => ({value, sort: Math.random()}))
    .sort((a, b) => a.sort - b.sort)
    .map(({value}) => value);

export const liff = {
  error: "",
  ready: true,
  init: async () => {},
  openWindow: async () => {},
  shareTargetPicker: async () => {},
  getDecodedIDToken: () => ({
    phone_number: "0912345678",
  }),
  getProfile: async () => {
    return {
      displayName: "高梓棋",
      pictureUrl:
        "https://profile.line-scdn.net/0hfDvHXsgROWtbMSo75WdHFCthOgF4QGB5d1B1DmhmY1w1CCo6JFEiXT5iYAk0Bi5qflJ2CDs5YF9XIk4NRWfFX1wBZ1xiBnc0fld0iQ",
      statusMessage: "I ain't going nowhere",
      userId: "U971712c7b73619805a898370d25867b8",
    };
  },
  getAccessToken: () =>
    "eyJhbGciOiJIUzI1NiJ9.eUHRtS3lrLLTw2ee4ogq8r1y2u6_o2bXfRELEEuOfU0uTyDPuynOaeI53h2h851clyBJcT2oHCPfEaPhWlzHvJuoiLJ1E8Ro1yZ_SO49LL3zafapc-IstMKAuZfo_enMeROonoF4JJGVLvuEn_BOYy30rPncFjw7K9dLlDlM5fw.zoiNpyQ7J4ZIx7mijr8TGQ0h7VwTnUst5ajVJwLx0l0",
  isLoggedIn: () => true,
  isInClient: () => false,
};
